import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import AddIcon from '@material-ui/icons/Add';
import CheckIcon from '@material-ui/icons/Check';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import green from '@material-ui/core/colors/green';
import SnackbarAlert from '../../Utils/SnackbarAlert';
import { handleServerError, handleSpecialCharacters } from '../../../Utils/Helper';
import InputLabel from '@material-ui/core/InputLabel';
import IconButton from '@material-ui/core/IconButton';
import AdminColorAPI from '../../../API/Admin/AdminColorAPI';
import EditIcon from '@material-ui/icons/Edit';
import ReactSelect from 'react-select';
import { components } from '../../Utils/ReactSelectComponents';
import DropdownListAPI from '../../../API/DropdownListAPI';

const styles = theme => ({
  paper: {
    position: 'absolute',
    width: '50%',
    minWidth: 240,
    backgroundColor: theme.palette.background.paper
  },
  toolbarRoot: {
    padding: 0,
    backgroundColor: theme.palette.primary.dark
  },
  width100: {
    width: '100%'
  },
  titleHead: {
    margin: '4px 12px',
    color: '#ffffff'
  },
  iconRight: {
    position: 'absolute',
    right: '12px'
  },
  formRoot: {
    flexGrow: 1,
    margin: '12px'
  },
  footer: {
    display: 'flex',
    position: 'relative'
  },
  buttonSuccess: {
    backgroundColor: green[400],
    '&:hover': {
      backgroundColor: green[600],
    },
  },
  fabProgress: {
    position: 'absolute',
    right: 2,
    bottom: 2,
    zIndex: 1
  },
  button: {
    margin: theme.spacing.unit,
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  },
  buttonSizeTbl: {
    width: '30px',
    height: '30px'
  },
  tblAdd: {
    color: '#ffffff',
    borderRadius: '50%',
    border: '1px solid #ffffff'
  },
  paddingAlign: {
    paddingTop: '6px'
  },
  group: {
    display: 'inline-block'
  },

  input: {
    display: 'flex',
    padding: 0
  }
});

function getModalPosition() {
  return {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  };
}


class AdminColorSalesForceModel extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      loading: false,
      success: false,
      elementId: '',
      brand: {},
      model: {},
      MarcaId:'',
      MarcaDesc: '',
      ModeloId:'',
      ModeloDesc: '',
      color: {},
      corId: '',
      corDesc: '',
      ColorName: '',
      ColorCombinationId: '',
      ColorHexCode: '',
      openError: false,
      alertMessage: '',
      brandData: [],
      colorData: []
    };
  }

  handleOpen = () => {
    if (this.props.element) {
      this.setState({
        openModal: true,
        elementId: this.props.element.Id,
        MarcaId: this.props.element.MarcaId,
        MarcaDesc: this.props.element.DescritivoMarca,
        ModeloId: this.props.element.ModeloId,
        ModeloDesc: this.props.element.DescritivoModelo,
        corId: this.props.element.corId,
        corDesc: this.props.element.corName,
        ColorName: this.props.element.ColorName,
        ColorCombinationId: this.props.element.ColorCombinationId,
        ColorHexCode: this.props.element.ColorHexCode
      });
    }
    else {
      this.setState({ openModal: true });
    }
    this.getAllBrandsAndColors();
  };

  getAllBrandsAndColors() {
    const dropdownListDataAPI = new DropdownListAPI();
    Promise.all([dropdownListDataAPI.getAllActiveBrandsForSF(), dropdownListDataAPI.getAllColors()]).then((response) => {
      this.setState({
        brandData: response[0].data,
        colorData: response[1].data,
        loading: false
      });
    }).catch((error) => {
      this.setState({
        openError: true,
        alertMessage: handleServerError(error)
      });
    });
  };

  handleClose = () => {
    this.setState({
      openModal: false,
      reloading: false,
      success: false
    });
  };

  handleChange = name => event => {
    this.setState({ [name]: handleSpecialCharacters(event.target.value) });
  };

  handleChangeSelect = name => value => {
    this.setState({ [name]: value });
  };

  handleChangeBrand = brandValue => {
    this.setState({ brand: brandValue, model: {} });
    const dropdownListDataAPI = new DropdownListAPI();
    dropdownListDataAPI.getAllActiveCarModelsByBrandForSF(brandValue.value).then((response) => {
      this.setState({
        carModelData: response.data
      });
    }).catch((error) => {
      this.setState({
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleClose();
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  handleCreate = () => {
    const adminAPI = new AdminColorAPI();
    this.setState({ reloading: true });
    let elementDTO = this.parseStateForCreate(this.state);
    adminAPI.saveSFColorsMatrix(elementDTO).then(() => {
      this.setState({
        reloading: false,
        success: true
      });
      setTimeout(() => {
        this.handleClose();
        this.props.reloadTable();
      }, 500)
    }).catch((error) => {
      this.setState({
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleClose();
    });
  };

  handleEdit = () => {
    const adminAPI = new AdminColorAPI();
    this.setState({ reloading: true })
    let elementDTO = this.parseStateForEdit(this.state);
    adminAPI.editSFColorsMatrix(elementDTO).then(() => {
      this.setState({
        reloading: false,
        success: true
      });
      setTimeout(() => {
        this.handleClose();
        this.props.reloadTable();
      }, 500)
    }).catch((error) => {
      this.setState({
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleClose();
    });
  };

  parseStateForEdit(estado) {
    let dto = {
      Id: estado.elementId,
      corID: estado.corId,
      ModeloId: estado.ModeloId,
      MarcaId: estado.MarcaId,
      ColorName: estado.ColorName,
      ColorCombinationId: estado.ColorCombinationId,
      ColorHexCode: estado.ColorHexCode,
    };
    return dto;
  };

  parseStateForCreate(estado) {
    let dto = {
      corID: estado.color.value,
      ModeloId: estado.model.value,
      MarcaId: estado.brand.value,
      ColorName: estado.ColorName,
      ColorCombinationId: estado.ColorCombinationId,
      ColorHexCode: estado.ColorHexCode,
    };
    return dto;
  };

  render() {
    const { classes } = this.props;
    const { reloading, success } = this.state;
    const buttonClassname = classNames({ [classes.buttonSuccess]: success });

    return (
      <div>

        {this.props.newEditButton ?
          <Tooltip title='Novo Elemento' placement='left-end' >
            <IconButton variant='fab' aria-label='New' onClick={this.handleOpen} className={classes.buttonSizeTbl}>
              <AddIcon className={classes.tblAdd} />
            </IconButton>
          </Tooltip>
          :
          <Tooltip title='Editar' placement='bottom' >
            <IconButton aria-label='Edit' onClick={this.handleOpen} className={classes.buttonSizeTbl} >
              <EditIcon />
            </IconButton>
          </Tooltip>
        }

        <Modal open={this.state.openModal} onClose={this.handleClose} disableAutoFocus={true}>
          <div style={getModalPosition()} className={classes.paper}>

            <Paper>
              <Toolbar className={classes.toolbarRoot}>
                <Typography variant='title' id='actionElement' className={classes.titleHead}>
                  {this.props.newEditButton ? 'NOVO ELEMENTO' : 'EDITAR ELEMENTO'}
                </Typography>
              </Toolbar>
            </Paper>

            <form className={classes.formRoot}>
              <Grid container spacing={8}>

                <Grid item xs={12} sm={6}>
                  {this.props.newEditButton ?
                    <Grid container justify='center'>
                      <div className={classes.width100}>
                        <InputLabel htmlFor='brand'>
                          MARCA
                        </InputLabel>
                        <ReactSelect
                          classes={classes}
                          options={this.state.brandData}
                          components={components}
                          value={this.state.brand}
                          onChange={this.handleChangeBrand}
                          placeholder=''
                        />
                      </div>
                    </Grid>
                    :
                  <TextField
                    id='marcaTf'
                    label='MARCA'
                    fullWidth
                    value={this.state.MarcaDesc}
                    className={classes.paddingAlign}
                    InputProps={{ readOnly: true }}
                  />}
                </Grid>

                <Grid item xs={12} sm={6}>
                  {this.props.newEditButton ?
                    <Grid container justify='center'>
                      <div className={classes.width100}>
                        <InputLabel htmlFor='DescritivoModelo'>
                          MODELO
                        </InputLabel>
                        <ReactSelect
                          classes={classes}
                          options={this.state.carModelData}
                          components={components}
                          value={this.state.model}
                          onChange={this.handleChangeSelect('model')}
                          placeholder=''
                        />
                      </div>
                    </Grid>
                  :
                  <TextField
                    id='modeloTf'
                    label='MODELO'
                    fullWidth
                    value={this.state.ModeloDesc}
                    className={classes.paddingAlign}
                    InputProps={{ readOnly: true }}
                  />}
                </Grid>

                <Grid item xs={12} sm={6}>
                  {this.props.newEditButton ?
                    <Grid container justify='center'>
                      <div className={classes.width100}>
                        <InputLabel htmlFor='color'>
                          COR
                        </InputLabel>
                        <ReactSelect
                          classes={classes}
                          options={this.state.colorData}
                          components={components}
                          value={this.state.color}
                          onChange={this.handleChangeSelect('color')}
                          placeholder=''
                        />
                      </div>
                    </Grid>
                  :
                  <TextField
                    id='corTf'
                    label='COR'
                    fullWidth
                    value={this.state.corDesc}
                    className={classes.paddingAlign}
                    InputProps={{ readOnly: true }}
                  />}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    id='ColorName'
                    label='COLOR NAME'
                    fullWidth
                    value={this.state.ColorName}
                    inputProps={{ maxLength: 100 }}
                    className={classes.paddingAlign}
                    onChange={this.handleChange('ColorName')}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    id='ColorCombinationId'
                    label='COMBINATION ID'
                    fullWidth
                    value={this.state.ColorCombinationId}
                    inputProps={{ maxLength: 100 }}
                    className={classes.paddingAlign}
                    onChange={this.handleChange('ColorCombinationId')}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    id='ColorHexCode'
                    label='HEXCODE'
                    fullWidth
                    value={this.state.ColorHexCode}
                    inputProps={{ maxLength: 100 }}
                    className={classes.paddingAlign}
                    onChange={this.handleChange('ColorHexCode')}
                  />
                </Grid>
              </Grid>
              <Toolbar className={classes.footer}>
                <div className={classes.iconRight}>
                  <Tooltip title='Cancelar' placement='bottom' >
                    <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClose}>
                      <CloseIcon />
                    </Button>
                  </Tooltip>
                  <Tooltip title='Guardar' placement='bottom' >
                    <Button disabled={reloading} variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize, buttonClassname)} onClick={this.props.newEditButton ? this.handleCreate : this.handleEdit}>
                      {success ? <CheckIcon /> : <SaveIcon />}
                    </Button>
                  </Tooltip>
                  {reloading && <CircularProgress size={48} color='primary' className={classes.fabProgress} />}
                </div>
              </Toolbar>

            </form>

          </div>
        </Modal>

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </div>
    );
  }
}

AdminColorSalesForceModel.propTypes = {
  classes: PropTypes.object.isRequired
};

export default AdminColorSalesForceModel = withStyles(styles)(AdminColorSalesForceModel);


// WEBPACK FOOTER //
// ./src/components/Administration/AdminColorSF/AdminColorSalesForceModel.js